import type { PurchaseAttachment } from '../types/purchasing';

export function purchaseReceipts(attachments: PurchaseAttachment[] | undefined): PurchaseAttachment[] {
  return (attachments || []).filter(
    file => file.kind === 'receipt' || file.storagePath.includes('/receipts/'),
  );
}

export function hasPurchaseReceipt(attachments: PurchaseAttachment[] | undefined): boolean {
  return purchaseReceipts(attachments).length > 0;
}

/**
 * Mark-purchased proof: a receipt file, a screenshot/PDF already on the request,
 * or a link that points at the receipt (often a Drive file).
 */
export function hasPurchaseReceiptProof(
  attachments: PurchaseAttachment[] | undefined,
  links?: Array<{ url?: string | null }> | null,
): boolean {
  if ((attachments || []).some(file => Boolean(file.storagePath || file.url || file.name))) return true;
  return (links || []).some(link => Boolean(String(link?.url || '').trim()));
}

export function purchaseSupportingFiles(attachments: PurchaseAttachment[] | undefined): PurchaseAttachment[] {
  return (attachments || []).filter(file => file.kind !== 'receipt');
}

/** Drop one attachment by storage path (legacy single-file PRs keep working). */
export function withoutPurchaseAttachment(
  attachments: PurchaseAttachment[] | undefined,
  storagePath: string,
): PurchaseAttachment[] {
  const path = (storagePath || '').trim();
  if (!path) return attachments ? [...attachments] : [];
  return (attachments || []).filter(file => file.storagePath !== path);
}
